module.exports = __webpack_public_path__ + "static/media/36.5245f120.jpg";